module.exports = __webpack_public_path__ + "static/media/meet-the-team-2.034a9770.png";